import { render } from "./TicketList.vue?vue&type=template&id=6c9b2f12"
import script from "./TicketList.vue?vue&type=script&lang=js"
export * from "./TicketList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__